import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Atom, Hourglass, Menu, Pill, Stethoscope, X } from 'lucide-react';
import { useSidebar } from '../../../../context/SidebarContext.jsx';
import styles from '../css/ReportsSidebar.module.css';

const ReportsSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isCollapsed, setIsCollapsed } = useSidebar();

  const isActive = (path) => location.pathname === path;

  const menuItems = [
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 4h9a2 2 0 0 1 2 2v11a3 3 0 0 1-3 3H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
          <path d="M9 8h6" />
          <path d="M9 12h6" />
          <path d="M9 16h4" />
          <path d="M6 8h.01" />
        </svg>
      ),
      label: 'Script Statistics',
      path: '/customer/dispensary/reports/script-statistics',
      active: isActive('/customer/dispensary/reports/script-statistics'),
    },
    {
      icon: (
        <Stethoscope size={22} />
      ),
      label: 'Doctor Statistics',
      path: '/customer/dispensary/reports/doctor-statistics',
      active: isActive('/customer/dispensary/reports/doctor-statistics'),
    },
    {
      icon: (
        <Pill size={22} />
      ),
      label: 'Medical Aid Statistics',
      path: '/customer/dispensary/reports/medical-aid-statistics',
      active: isActive('/customer/dispensary/reports/medical-aid-statistics'),
    },
    {
      icon: (
        <Atom size={22} />
      ),
      label: 'Healthnet Statistics',
      path: '/customer/dispensary/reports/healthnet-statistics',
      active: isActive('/customer/dispensary/reports/healthnet-statistics'),
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="6" y="3" width="14" height="18" rx="2" />
          <path d="M10 7h6" />
          <path d="M10 11h6" />
          <path d="M10 15h6" />
          <path d="M8 7h.01" />
          <path d="M8 11h.01" />
          <path d="M8 15h.01" />
        </svg>
      ),
      label: 'Script Totals per Medical Aid',
      path: '/customer/dispensary/reports/script-totals-per-medical-aid',
      active: isActive('/customer/dispensary/reports/script-totals-per-medical-aid'),
    },
    {
      icon: (
        <Hourglass size={22} />
      ),
      label: 'Hourly Distribution',
      path: '/customer/dispensary/reports/hourly-distribution',
      active: isActive('/customer/dispensary/reports/hourly-distribution'),
    }
  ];

  return (
    <div className={`${styles.sidebar} ${isCollapsed ? styles.collapsed : ''}`}>
      <div className={styles.sidebarHeader}>
        <button
          type="button"
          className={styles.toggleButton}
          onClick={() => setIsCollapsed(!isCollapsed)}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? <Menu size={20} /> : <X size={20} />}
        </button>
      </div>

      <div className={styles.menuContainer}>
        {menuItems.map((item, index) => (
          <div key={index} className={styles.menuCard}>
            <div
              className={`${styles.menuItem} ${item.active ? styles.active : ''}`}
              role="button"
              tabIndex={0}
              onClick={() => navigate(item.path)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') navigate(item.path);
              }}
              title={isCollapsed ? item.label : undefined}
            >
              <div className={styles.iconWrap}>{item.icon}</div>
              {!isCollapsed && <span className={styles.label}>{item.label}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportsSidebar;
